import { PortalProps } from "types/types";
import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";

function createProtal() {
  let closed = false;
  function Portal({ children }: PortalProps) {
    const portalRef = useRef(false);
    useEffect(() => {
      return () => {
        closed = false;
      };
    }, []);
    let renderedPortal = null;
    if (
      typeof document !== "undefined" &&
      (closed === false || portalRef.current === true)
    ) {
      closed = true;
      portalRef.current = true;
      renderedPortal = ReactDOM.createPortal(
        children,
        document.getElementById("modal-root") as HTMLElement,
      );
    }
    return renderedPortal;
  }
  return Portal;
}
export default createProtal();
